module.exports = __webpack_public_path__ + "img/u11.62083857.jpg";